import { Box } from "@chakra-ui/react";
import React, { useMemo } from "react";
import SystemChat from "./chat/roles/system/systemChat";
import UserChat from "./chat/roles/user/userChat";
import { SYSTEM_CHAT_LAST_ITEM_OFFSET } from "@root/constants/common";

const ChatBodyNew = ({
  chat,
  isLastSystemMessage,
}: {
  chat: any;
  isLastSystemMessage: boolean;
}) => {
  const lastSystemChatMinHeight = useMemo(
    () => `calc(100vh - ${SYSTEM_CHAT_LAST_ITEM_OFFSET}px)`,
    []
  );

  return (
    <Box minH={isLastSystemMessage ? lastSystemChatMinHeight : "auto"}>
      {chat?.role === "user" && <UserChat chat={chat} />}
      {chat?.role === "assistent" && (
        <Box>
          <SystemChat chat={chat} isLastSystemMessage={isLastSystemMessage} />
        </Box>
      )}
    </Box>
  );
};

export default ChatBodyNew;
